module.exports = __webpack_public_path__ + "static/media/README.ed623263.md";